export default
  {
    FooterRoutes: [

      {
        value: 1,
        title: 'Stable Hundreds of Hosting',
        routes: [
          {
            title: 'Aparthotels',
            route: 'apartahoteles'
          },
          {
            title: 'Hoteles',
            route: 'hoteles'
          },
          {
            title: 'Restaurantes',
            route: 'restaurantes'
          },
          {
            title: 'Cafeterias',
            route: 'cafeterias'
          },
          {
            title: 'Discotecas',
            route: 'discotecas'
          },
          {
            title: 'Bares',
            route: 'bares'
          },
        ]
      },
      {
        value: 2,
        title: 'Gift shops',
        routes: [
          {
            title: 'Tiendas de artesania',
            route: 'tiendas-de-artesania'
          },
          {
            title: 'Joyeria',
            route: 'joyeria'
          },
          {
            title: 'Cigar shop',
            route: 'cigar-shop'
          },
          {
            title: 'Galeria de arte',
            route: 'galeria-de-arte'
          },
          {
            title: 'Minimarket',
            route: 'minimarket'
          },
          {
            title: 'Liquor Store',
            route: 'liquor-store'
          },
        ]
      },
      {
        value: 3,
        title: 'Agencias de viaje y tour operador',
        routes: [
          {
            title: 'Agencias de viajes mayorista',
            route: 'agencias-de-viajes-mayorista'
          },
          {
            title: 'Agencias de viajes, reservas y pasajes',
            route: 'Agencias de viajes, reservas y pasajes'
          },
          {
            title: 'Tour operador receptivo-emitivo',
            route: 'Tour operador receptivo-emitivo'
          },
          {
            title: 'Tour operador local-doméstico',
            route: 'Tour operador local-doméstico'
          }
        ]
      },
      {
        value: 4,
        title: 'Viajes en botes',
        routes: [
          {
            title: 'Bote',
            route: 'Bote'
          },
          {
            title: 'Catamaran motorizado',
            route: 'Catamaran motorizado'
          },
          {
            title: 'Speed boat',
            route: 'Speed boat'
          },
          {
            title: 'Velero',
            route: 'Velero'
          }
        ]
      },
      {
        value: 5,
        title: 'Turismo de aventura',
        routes: [
          {
            title: 'Escuela de buceo',
            route: 'Escuela de buceo'
          },
          {
            title: 'Pesca',
            route: 'Pesca'
          },
          {
            title: 'Paintball',
            route: 'Paintball'
          },
          {
            title: 'Zip line-Canopy',
            route: 'Zip line-Canopy'
          }
        ]
      },
      {
        value: 6,
        title: 'Turismo de Caminata',
        routes: [
          {
            title: 'Escuela de buceo',
            route: 'Escuela de buceo'
          },
          {
            title: 'Pesca',
            route: 'Pesca'
          },
          {
            title: 'Paintball',
            route: 'Paintball'
          },
          {
            title: 'Zip line-Canopy',
            route: 'Zip line-Canopy'
          }
        ]
      },
    ]
  }